import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { OpportunitiesListComponent } from '@pages/opportunities/opportunities-list/opportunities-list.component';
import { FilterStateService } from '@services/filter-state.service';
import { OpportunitiesFiltersComponent } from '@shared/opportunities-filters/opportunities-filters.component';
import {
    IAdditionalFiltersOpportunities,
    IMainFiltersOpportunities,
    OPPORTUNITIES_CONTACT_FILTER_KEY
} from '@shared/opportunities-filters/opportunity-filters.config';

@Component({
    selector: 'app-contacts-single-opportunities',
    templateUrl: './contacts-single-opportunities.component.html',
    styleUrls: ['./contacts-single-opportunities.component.scss'],
    imports: [OpportunitiesFiltersComponent, OpportunitiesListComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: FilterStateService,
            useClass: FilterStateService<IMainFiltersOpportunities, IAdditionalFiltersOpportunities>
        }
    ]
})
export class ContactsSingleOpportunitiesComponent {
    readonly contactId = input<number>();

    readonly filtersKey = OPPORTUNITIES_CONTACT_FILTER_KEY;
}
